import { authUser, clearAuth } from "../store/auth.js";

/**
 * Authenticated fetch wrapper that injects Bearer token
 * and handles 401 responses by clearing auth state.
 */
export async function apiFetch(
  path: string,
  init?: RequestInit,
): Promise<Response> {
  const token = authUser.peek()?.accessToken;
  const headers = new Headers(init?.headers);
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  if (!headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  const res = await fetch(path, { ...init, headers });

  if (res.status === 401) {
    clearAuth();
  }

  return res;
}
